<template>
  <div>
    <headFile class="headFile"></headFile>
    <div class="container">
      <router-view></router-view>
    </div>
    <Footer/>
  </div>
</template>

<script>
import headFile from "@/components/headFile";
import Footer from '../components/foot.vue';
export default {
  name: "index",
  data() {
    return {};
  },
  components: {
    headFile,
    Footer
  },
};
</script>

<style>
p{
    margin: 0;
}
</style>